<template>
  <div v-bind="$attrs">

    <textarea 
      class="textarea" 
      :class="textAreaClass"
      :placeholder="placeholder"
      :value="value"
      @input="changeValue($event)"
      @blur="blur($event); validate($event.target.value)"
      :required="required"
      :disabled="disabled"
      :rows="rows">
    </textarea>

    <div class="level" v-if="counter || hasError">
      <div class="help has-text-danger pl-1">
        <div 
          v-for="(error, i) in errors"
          :key="i">
          {{ error }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import validatable from '@/mixins/validatable.js'

export default {
  props: {
    value: {
      type: [String, Number]
    },
    placeholder: {
      type: [String, Number],
      default: 'Input text here'
    },
    rows: {
      type: [String, Number],
      default: '5'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [validatable],
  computed: {
    textAreaClass() {
      return {
        'is-danger': this.hasError
      }
    }
  },
  methods: {
    changeValue(e) {
      this.$emit('input', e.target.value);
      this.validate(e.target.value);
    },
    blur(e) {
      this.$emit('blur', e.target.value);
    }
  }
}
</script>
